declare global {
  interface Window {
    __googleTranslateFixApplied?: boolean;
  }
}

export function applyGoogleTranslateFix() {
  if (typeof window !== "undefined" && !window.__googleTranslateFixApplied) {
    const originalRemoveChild = Node.prototype.removeChild;

    Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
      try {
        return originalRemoveChild.call(this, child) as T;
      } catch (error) {
        if (error instanceof DOMException && error.name === "NotFoundError") {
          return child;
        }
        throw error;
      }
    };

    const originalInsertBefore = Node.prototype.insertBefore;

    Node.prototype.insertBefore = function <T extends Node>(
      this: Node,
      newNode: T,
      referenceNode: Node | null
    ): T {
      try {
        return originalInsertBefore.call(this, newNode, referenceNode) as T;
      } catch (error) {
        if (error instanceof DOMException && error.name === "NotFoundError") {
          return this.appendChild(newNode) as T;
        }
        throw error;
      }
    };

    window.__googleTranslateFixApplied = true;
  }
}
